/**
 * 动态加载js脚本
 * @param  {string} url       js脚本地址
 * @param  {Partial<HTMLScriptElement>} [attr={}] 需要给`script`标签额外指定的属性
 * @param {(el: HTMLScriptElement) => void} [returnScript] 返回script对象
 * @return {Promise<HTMLScriptElement>}    返回一个Promise对象
 */
function loadScript(url, attr, returnScript) {
    return new Promise((resolve, reject) => {
        const $script = document.createElement('script');
        $script.type = 'text/javascript';
        if (attr) {
            let key;
            for (key in attr) {
                const v = attr[key];
                $script[key] = v;
            }
        }
        const onLoad = () => {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            cleanup();
            resolve($script);
        };
        const onError = (evt) => {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            cleanup();
            document.body.removeChild($script);
            reject(evt.error || new Error(`load script error: ${url}`));
        };
        const cleanup = () => {
            $script.removeEventListener('load', onLoad);
            $script.removeEventListener('error', onError);
        };
        $script.src = url;
        $script.addEventListener('load', onLoad);
        $script.addEventListener('error', onError);
        document.body.appendChild($script);
        returnScript && returnScript($script);
    });
}
export default loadScript;
//# sourceMappingURL=load-script.js.map